/**
 * Convenience class to store data in local storage.
 * @class LocalStorage
 * @since 1.0.0
 */
export class LocalStorage {
    //--------------------------------------------------------------------------
    // Methods
    //--------------------------------------------------------------------------
    /**
     * Sets a value in storage.
     * @method set
     * @since 1.0.0
     */
    static set(key, val) {
        if (val == null) {
            remove(key);
            return;
        }
        set(key, encode(val));
    }
    /**
     * Retrieves a value from storage.
     * @method set
     * @since 1.0.0
     */
    static get(key, defaults = null) {
        const val = get(key);
        if (val == null) {
            return defaults;
        }
        return decode(val);
    }
}
/**
 * @function set
 * @since 1.0.0
 * @hidden
 */
function set(key, val) {
    return localStorage.setItem(key, val);
}
/**
 * @function get
 * @since 1.0.0
 * @hidden
 */
function get(key) {
    return localStorage.getItem(key);
}
/**
 * @function remove
 * @since 1.0.0
 * @hidden
 */
function remove(key) {
    return localStorage.removeItem(key);
}
/**
 * @function encode
 * @since 1.0.0
 * @hidden
 */
function encode(value) {
    return JSON.stringify(value);
}
/**
 * @function decode
 * @since 1.0.0
 * @hidden
 */
function decode(value) {
    return JSON.parse(value);
}
